var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("div", [
          _c("article", { staticClass: "box" }, [
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.value.isAudaBridge
                          ? _vm.pnetAudanetMenuText
                          : "PNET" + _vm.pnetAudanetMenuText
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "column is-narrow" }, [
                _vm.value.isPnet && !_vm.value.isAudaBridge
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.value.isNew,
                            expression: "!value.isNew",
                          },
                        ],
                        staticClass: "dropdown is-right is-hoverable",
                      },
                      [
                        _vm._m(0),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-menu",
                            attrs: { id: "dropdown-menu-pnet", role: "menu" },
                          },
                          [
                            _c("div", { staticClass: "dropdown-content" }, [
                              !_vm.value.isAudaNet && _vm.isSubmitQuoteEnabled
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: { click: _vm.submitPnetQuote },
                                    },
                                    [
                                      _vm._m(1),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Submit Quote")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              !_vm.value.isAudaNet &&
                              _vm.isSubmitSupplementaryEnabled
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: { click: _vm.submitPnetQuote },
                                    },
                                    [
                                      _vm._m(2),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Submit Supplementary Quote")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isSubmitQuoteUpdateEnabled
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: { click: _vm.submitPnetQuoteUpdate },
                                    },
                                    [
                                      _vm._m(3),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Submit Repair Status")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isSubmitTaxInvoiceEnabled
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: { click: _vm.submitTaxInvoice },
                                    },
                                    [
                                      _vm._m(4),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Submit Tax Invoice")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              (!_vm.value.isAudaNet &&
                                (_vm.isSubmitQuoteEnabled ||
                                  _vm.isSubmitSupplementaryEnabled)) ||
                              _vm.isSubmitQuoteUpdateEnabled ||
                              _vm.isSubmitTaxInvoiceEnabled
                                ? _c("hr", { staticClass: "dropdown-divider" })
                                : _vm._e(),
                              _vm.$userInfo.isSupportUser
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showUtilities()
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(5),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Utilities")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "dropdown-item dropdown-item-has-icon",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewMessages("PNET")
                                    },
                                  },
                                },
                                [
                                  _vm._m(6),
                                  _c(
                                    "span",
                                    { staticClass: "dropdown-item-text" },
                                    [_vm._v("View Messages")]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "column is-narrow" }, [
                _vm.value.isAudaNet || _vm.value.isAudaBridge
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.value.isNew,
                            expression: "!value.isNew",
                          },
                        ],
                        staticClass: "dropdown is-right is-hoverable",
                      },
                      [
                        _c("div", { staticClass: "dropdown-trigger" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button",
                              attrs: {
                                "aria-haspopup": "true",
                                "aria-controls": "dropdown-menu-audanet",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.dropdownMenuText)),
                              ]),
                              _vm._m(7),
                            ]
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-menu",
                            attrs: {
                              id: "dropdown-menu-audanet",
                              role: "menu",
                            },
                          },
                          [
                            _c("div", { staticClass: "dropdown-content" }, [
                              _vm.value.isAudaNet
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: {
                                        click: _vm.showDownloadAudaNetQuote,
                                      },
                                    },
                                    [
                                      _vm._m(8),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Download Quote")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.value.isAudaNet
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: { click: _vm.downloadImages },
                                    },
                                    [
                                      _vm._m(9),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Download Files")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.value.isAudaNet
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: { click: _vm.updateClaimInfo },
                                    },
                                    [
                                      _vm._m(10),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Update Claim Info")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.value.isAudaNet
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: { click: _vm.downloadVehicle },
                                    },
                                    [
                                      _vm._m(11),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Update Vehicle")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.value.isAudaNet && !_vm.disableSumbitItems
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showSubmitAudaNetItems()
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(12),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Submit Items")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.value.isAudaBridge
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: { click: _vm.submitImages },
                                    },
                                    [
                                      _vm._m(13),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Submit Images")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.value.isAudaNet
                                ? _c("hr", { staticClass: "dropdown-divider" })
                                : _vm._e(),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "dropdown-item dropdown-item-has-icon",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewMessages("audanet")
                                    },
                                  },
                                },
                                [
                                  _vm._m(14),
                                  _c(
                                    "span",
                                    { staticClass: "dropdown-item-text" },
                                    [_vm._v("View Messages")]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "columns" }, [
                _vm.value.pnet
                  ? _c("div", { staticClass: "column" }, [
                      _c("label", { staticClass: "label" }, [_vm._v("PNET")]),
                      _c("div", { staticClass: "columns" }, [
                        _c("div", { staticClass: "column is-narrow" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table is-bordered is-striped table-max-width",
                            },
                            [
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-weight-bold has-vertical-middle",
                                    attrs: { nowrap: "" },
                                  },
                                  [_vm._v("Quote Status")]
                                ),
                                _c("td", [
                                  _vm.$userInfo.isSupportUser
                                    ? _c(
                                        "div",
                                        { staticClass: "select is-fullwidth" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.value.pnet
                                                      .quoteStatusId,
                                                  expression:
                                                    "value.pnet.quoteStatusId",
                                                },
                                              ],
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    _vm.value.pnet,
                                                    "quoteStatusId",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            _vm._l(
                                              _vm.quoteStatusTypes,
                                              function (type) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: type.value,
                                                    domProps: {
                                                      value: type.value,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(type.name) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      )
                                    : _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.quoteStatusTypes?.find(
                                              (s) =>
                                                s.value ===
                                                _vm.value.pnet.quoteStatusId
                                            )?.name
                                          )
                                        ),
                                      ]),
                                ]),
                              ]),
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-weight-bold has-vertical-middle",
                                    attrs: { nowrap: "" },
                                  },
                                  [_vm._v("Quote Request No.")]
                                ),
                                _c("td", [
                                  _vm.$userInfo.isSupportUser
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.value.pnet.quoteRequestNo,
                                            expression:
                                              "value.pnet.quoteRequestNo",
                                          },
                                        ],
                                        staticClass: "input is-uppercase",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Quote Request No.",
                                        },
                                        domProps: {
                                          value: _vm.value.pnet.quoteRequestNo,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.value.pnet,
                                              "quoteRequestNo",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.value.pnet.quoteRequestNo)
                                        ),
                                      ]),
                                ]),
                              ]),
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-weight-bold has-vertical-middle",
                                    attrs: { nowrap: "" },
                                  },
                                  [_vm._v("Quote Request Version")]
                                ),
                                _c("td", [
                                  _vm.$userInfo.isSupportUser
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.value.pnet
                                                .quoteRequestVersion,
                                            expression:
                                              "value.pnet.quoteRequestVersion",
                                          },
                                        ],
                                        staticClass: "input is-uppercase",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Quote Request Version",
                                        },
                                        domProps: {
                                          value:
                                            _vm.value.pnet.quoteRequestVersion,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.value.pnet,
                                              "quoteRequestVersion",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.value.pnet.quoteRequestVersion
                                          )
                                        ),
                                      ]),
                                ]),
                              ]),
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-weight-bold has-vertical-middle",
                                    attrs: { nowrap: "" },
                                  },
                                  [_vm._v("PNET Quote No.")]
                                ),
                                _c("td", [
                                  _vm.$userInfo.isSupportUser
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.value.pnet.pnetQuoteNo,
                                            expression:
                                              "value.pnet.pnetQuoteNo",
                                          },
                                        ],
                                        staticClass: "input is-uppercase",
                                        attrs: {
                                          type: "text",
                                          placeholder: "PNET Quote No.",
                                        },
                                        domProps: {
                                          value: _vm.value.pnet.pnetQuoteNo,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.value.pnet,
                                              "pnetQuoteNo",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.value.pnet.pnetQuoteNo)
                                        ),
                                      ]),
                                ]),
                              ]),
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-weight-bold has-vertical-middle",
                                    attrs: { nowrap: "" },
                                  },
                                  [_vm._v("Authorised Quote No.")]
                                ),
                                _c("td", [
                                  _vm.$userInfo.isSupportUser
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.value.pnet.authorisedQuoteNo,
                                            expression:
                                              "value.pnet.authorisedQuoteNo",
                                          },
                                        ],
                                        staticClass: "input is-uppercase",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Authorised Quote No.",
                                        },
                                        domProps: {
                                          value:
                                            _vm.value.pnet.authorisedQuoteNo,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.value.pnet,
                                              "authorisedQuoteNo",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.value.pnet.authorisedQuoteNo
                                          )
                                        ),
                                      ]),
                                ]),
                              ]),
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-weight-bold has-vertical-middle",
                                    attrs: { nowrap: "" },
                                  },
                                  [_vm._v("Authority No.")]
                                ),
                                _c(
                                  "td",
                                  { staticClass: "has-vertical-middle" },
                                  [
                                    _vm.$userInfo.isSupportUser
                                      ? _c("the-mask", {
                                          staticClass: "input",
                                          attrs: {
                                            placeholder: "Authority No.",
                                            mask: ["####################"],
                                          },
                                          model: {
                                            value: _vm.value.pnet.authorityNo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.value.pnet,
                                                "authorityNo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "value.pnet.authorityNo",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.value.pnet.authorityNo)
                                          ),
                                        ]),
                                  ],
                                  1
                                ),
                              ]),
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-weight-bold has-vertical-middle",
                                    attrs: { nowrap: "" },
                                  },
                                  [_vm._v("Payment Response")]
                                ),
                                _c("td", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.value.pnet.paymentResponse)
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                        _vm.value.pnet && _vm.$userInfo.isSupportUser
                          ? _c("div", { staticClass: "column" }, [
                              _c(
                                "div",
                                { staticClass: "field has-checkradio" },
                                [
                                  _c("div", { staticClass: "control" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.value.pnet.extraVehicleInfo,
                                          expression:
                                            "value.pnet.extraVehicleInfo",
                                        },
                                      ],
                                      staticClass: "is-checkradio is-primary",
                                      class: {
                                        "has-background-color":
                                          _vm.value.pnet.extraVehicleInfo,
                                      },
                                      attrs: {
                                        type: "checkbox",
                                        id: "extraVehicleInfo",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.value.pnet.extraVehicleInfo
                                        )
                                          ? _vm._i(
                                              _vm.value.pnet.extraVehicleInfo,
                                              null
                                            ) > -1
                                          : _vm.value.pnet.extraVehicleInfo,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.value.pnet.extraVehicleInfo,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.value.pnet,
                                                  "extraVehicleInfo",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.value.pnet,
                                                  "extraVehicleInfo",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.value.pnet,
                                              "extraVehicleInfo",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      { attrs: { for: "extraVehicleInfo" } },
                                      [_vm._v("Extra Vehicle Info")]
                                    ),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
                _vm.value.audatex
                  ? _c("div", { staticClass: "column" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.dropdownMenuText)),
                      ]),
                      _c(
                        "table",
                        {
                          staticClass:
                            "table is-bordered is-striped table-max-width",
                        },
                        [
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass:
                                  "has-text-weight-bold has-vertical-middle",
                                attrs: { nowrap: "" },
                              },
                              [_vm._v("Display Name")]
                            ),
                            _c("td", [
                              _vm.$userInfo.isSupportUser
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.value.audatex.displayName,
                                        expression: "value.audatex.displayName",
                                      },
                                    ],
                                    staticClass: "input is-uppercase",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Display Name",
                                    },
                                    domProps: {
                                      value: _vm.value.audatex.displayName,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.value.audatex,
                                          "displayName",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.value.audatex.displayName)
                                    ),
                                  ]),
                            ]),
                          ]),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "has-text-weight-bold",
                                attrs: { nowrap: "" },
                              },
                              [_vm._v("Calculation ID")]
                            ),
                            _c("td", [
                              _vm._v(_vm._s(_vm.value.audatex.calculationId)),
                            ]),
                          ]),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "has-text-weight-bold",
                                attrs: { nowrap: "" },
                              },
                              [_vm._v("Calculation Status")]
                            ),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.value.audatex.calculationStatus)
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "has-text-weight-bold",
                                attrs: { nowrap: "" },
                              },
                              [_vm._v("Business Status")]
                            ),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.value.audatex.businessStatusText)
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "has-text-weight-bold",
                                attrs: { nowrap: "" },
                              },
                              [_vm._v("Quote Stage")]
                            ),
                            _c("td", [
                              _vm._v(_vm._s(_vm.value.audatex.quoteStage)),
                            ]),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm.value.audatex && _vm.disableSumbitItems
                ? _c("div", { staticClass: "unread-messages-section" }, [
                    _c("div", { staticClass: "is-flex flex-start" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "material-symbols-outlined has-text-warning mr-2",
                        },
                        [_vm._v(" warning ")]
                      ),
                      _c("div", [
                        _c("p", { staticClass: "mb-3" }, [
                          _c("strong", [_vm._v("Note:")]),
                          _vm._v(" The "),
                          _c("strong", [_vm._v("Submit Items")]),
                          _vm._v(
                            " button is currently disabled because the quote status is "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.currentQuoteStatus)),
                          ]),
                          _vm._v(
                            ". If you intend to submit supplementary items, please create the Supp in AudaNet first. "
                          ),
                        ]),
                      ]),
                    ]),
                    _vm.displayDownloadQuoteMessage
                      ? _c("div", { staticClass: "is-flex flex-start" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "material-symbols-outlined has-text-warning mr-2",
                            },
                            [_vm._v(" warning ")]
                          ),
                          _c("div", [
                            _c("p", { staticClass: "mb-3" }, [
                              _c("strong", [_vm._v("Download Required:")]),
                              _vm._v(" This quote is "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.currentQuoteStatus)),
                              ]),
                              _vm._v(
                                ". Please download the quote from AudaNet to sync all updates. "
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c(
            "article",
            { staticClass: "box" },
            [
              _c("p", { staticClass: "title" }, [_vm._v("Remarks")]),
              _c(
                "bulma-table",
                {
                  staticClass:
                    "table is-bordered is-striped is-narrow is-fullwidth",
                  attrs: {
                    columns: _vm.columns,
                    "page-index": _vm.filter.pageIndex,
                    "page-size": _vm.filter.pageSize,
                    "total-rows": _vm.remarkTotalRows,
                    "is-loading": _vm.isTableLoading,
                    "sort-column": _vm.filter.sortColumn,
                    "sort-order": _vm.filter.sortOrder,
                    "show-header": false,
                  },
                  on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                },
                [
                  _vm._l(_vm.pagedRemarks, function (remark, index) {
                    return _c(
                      "tr",
                      {
                        key: remark.remarkId,
                        on: {
                          click: function ($event) {
                            return _vm.highlightSelected(index, $event)
                          },
                        },
                      },
                      [
                        _c("td", { staticClass: "is-content-width" }, [
                          _c("span", { staticClass: "tag is-info" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatDateTimeLocale(
                                  remark.remarkDateTime,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c("td", { staticClass: "is-remark" }, [
                          _c("div", [_vm._v(_vm._s(remark.remarks))]),
                        ]),
                      ]
                    )
                  }),
                  _c("template", { slot: "empty" }, [
                    _c("section", { staticClass: "section" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content has-text-grey has-text-centered",
                        },
                        [
                          _c("span", { attrs: { icon: "icon is-large" } }, [
                            _c("i", {
                              staticClass: "mdi mdi-48px mdi-emoticon-sad",
                            }),
                          ]),
                          _c("p", [_vm._v("Nothing")]),
                        ]
                      ),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm.isDownloadQuoteModalActive
        ? _c("audanet-download-quote-modal", {
            attrs: { active: _vm.isDownloadQuoteModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isDownloadQuoteModalActive = $event
              },
              cancel: function ($event) {
                _vm.isDownloadQuoteModalActive = false
              },
              download: _vm.downloadQuote,
            },
          })
        : _vm._e(),
      _vm.isSubmitItemsModalActive
        ? _c("audanet-submit-items-modal", {
            attrs: { active: _vm.isSubmitItemsModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isSubmitItemsModalActive = $event
              },
              cancel: function ($event) {
                _vm.isSubmitItemsModalActive = false
              },
              submit: _vm.submitItems,
            },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          })
        : _vm._e(),
      _vm.isXmlViewerModalActive
        ? _c(
            "xml-viewer-modal",
            {
              attrs: {
                active: _vm.isXmlViewerModalActive,
                "quote-id": _vm.value.quoteId,
                "message-type": _vm.messageType,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isXmlViewerModalActive = $event
                },
                close: function ($event) {
                  _vm.isXmlViewerModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("View " + _vm._s(_vm.messageType) + " Messages"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.isPnetSubmitQuoteModalActive
        ? _c(
            "pnet-submit-quote-modal",
            {
              attrs: {
                active: _vm.isPnetSubmitQuoteModalActive,
                vehicle: _vm.vehicle,
                customer: _vm.customer,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isPnetSubmitQuoteModalActive = $event
                },
                close: function ($event) {
                  _vm.isPnetSubmitQuoteModalActive = false
                },
              },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Submit PNET Quote"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.isPnetSubmitQuoteUpdateModalActive
        ? _c(
            "pnet-submit-quote-update-modal",
            {
              attrs: {
                active: _vm.isPnetSubmitQuoteUpdateModalActive,
                vehicle: _vm.vehicle,
                customer: _vm.customer,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isPnetSubmitQuoteUpdateModalActive = $event
                },
                close: function ($event) {
                  _vm.isPnetSubmitQuoteUpdateModalActive = false
                },
              },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Submit PNET Quote Update"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.isAudabridgeSubmitImagesModalActive
        ? _c("audabridge-submit-images-modal", {
            attrs: {
              active: _vm.isAudabridgeSubmitImagesModalActive,
              "quote-id": _vm.value.quoteId,
            },
            on: {
              "update:active": function ($event) {
                _vm.isAudabridgeSubmitImagesModalActive = $event
              },
              cancel: function ($event) {
                _vm.isAudabridgeSubmitImagesModalActive = false
              },
            },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          })
        : _vm._e(),
      _vm.isPnetUtilitiesModalActive
        ? _c("orm-pnet-utilities-modal", {
            attrs: { active: _vm.isPnetUtilitiesModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isPnetUtilitiesModalActive = $event
              },
            },
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = $$v
              },
              expression: "innerValue",
            },
          })
        : _vm._e(),
      _c(
        "confirm-modal",
        {
          attrs: {
            active: _vm.isCreateSubQuoteModalActive,
            "ok-text": "Yes",
            "cancel-text": "No",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCreateSubQuoteModalActive = $event
            },
            ok: function ($event) {
              return _vm.createSubQuote(true)
            },
            cancel: function ($event) {
              return _vm.createSubQuote(false)
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Create Supplementary Quote"),
          ]),
          _c(
            "section",
            { attrs: { slot: "text-content" }, slot: "text-content" },
            [
              _vm.isCreateSubQuoteModalActive
                ? _c("div", [
                    _c("p", [
                      _vm._v(
                        "Found new supplementary quote added in " +
                          _vm._s(_vm.dropdownMenuText)
                      ),
                    ]),
                    _c("br"),
                    _c("p", { staticStyle: { "margin-left": "2em" } }, [
                      _vm._v(" Quote No.: "),
                      _c(
                        "span",
                        {
                          staticClass: "has-text-primary has-text-weight-bold",
                        },
                        [_vm._v(_vm._s(_vm.subQuoteSummary.quoteNoRef))]
                      ),
                      _c("br"),
                      _vm._v("Current Supp: "),
                      _c(
                        "span",
                        {
                          staticClass: "has-text-primary has-text-weight-bold",
                        },
                        [_vm._v(_vm._s(_vm.subQuoteSummary.subQuoteNo))]
                      ),
                      _c("br"),
                      _vm._v("New supp: "),
                      _c(
                        "span",
                        {
                          staticClass: "has-text-primary has-text-weight-bold",
                        },
                        [_vm._v(_vm._s(_vm.subQuoteSummary.createSubQuoteNo))]
                      ),
                    ]),
                    _c("br"),
                    _vm._v(" Create new supplementary quote? "),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dropdown-trigger" }, [
      _c(
        "button",
        {
          staticClass: "button",
          attrs: {
            "aria-haspopup": "true",
            "aria-controls": "dropdown-menu-pnet",
          },
        },
        [
          _c("span", [_vm._v("PNET")]),
          _c("span", { staticClass: "icon is-small" }, [
            _c("i", {
              staticClass: "mdi mdi-chevron-down",
              attrs: { "aria-hidden": "true" },
            }),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-upload mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-upload-outline mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-update mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-currency-usd mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "icon is-small is-left has-text-primary",
        staticStyle: { "self-align": "center" },
      },
      [_c("i", { staticClass: "mdi mdi-tools mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "icon is-small is-left has-text-primary",
        staticStyle: { "self-align": "center" },
      },
      [_c("i", { staticClass: "mdi mdi-file-code mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", {
        staticClass: "mdi mdi-chevron-down",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-download mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-image-plus mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-shield-car mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-car mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-upload-multiple mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-image-move mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "icon is-small is-left has-text-primary",
        staticStyle: { "self-align": "center" },
      },
      [_c("i", { staticClass: "mdi mdi-file-code mdi-18px" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }